const generalModule = {
  state: {
    isLoading: 0,
    authToShow: 'register',
  },

  mutations: {
    SET_LOADING(state, value) {
      state.isLoading = value;
    },
    SET_AUTH_TO_SHOW(state, value) {
      state.authToShow = value;
    },
  },

  actions: {
    setLoading(context, value) {
      context.commit('SET_LOADING', value);
    },
    setAuthToShow(context, value) {
      context.commit('SET_AUTH_TO_SHOW', value);
    },
  },
};

export default generalModule;
